var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }